require("./lib/ads");
var paywall = require("./lib/paywall");
setTimeout(() => paywall(11176774), 3000);

var track = require("./lib/tracking");

require("component-responsive-frame/child");

require("./bc-preroll");

